import {
  GET_YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_DETAILS
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampDataProgramAndPropertyList =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataProgramAndProperty =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_FAILURE,
        payload: error
      }),
      dispatch
    });

export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
